<script setup>
import { renderRichText } from "@storyblok/vue";

defineProps({ blok: Object });
</script>

<template>
  <v-row
    class="dos-donts bg-lightGray pa-4 mt-6 mb-6"
    v-if="blok?.dosImage?.filename || blok?.dos?.content[0]?.content"
  >
    <v-col cols="12" :md="blok?.dosImage?.filename ? '6' : '12'">
      <p class="mb-2 text-primary font-weight-bold">{{ $t("dos") }}</p>
      <div v-html="renderRichText(blok.dos)" class="dos" />
    </v-col>
    <v-col cols="12" md="6" v-if="blok?.dosImage?.filename">
      <div class="dos-donts__image-container">
        <img
          class="dos-donts__image-container--image"
          :src="blok.dosImage.filename"
          :alt="blok.dosImage.alt"
        />
      </div>
    </v-col>
  </v-row>

  <v-row
    class="dos-donts bg-lightGray pa-4 mt-6 mb-6"
    v-if="blok?.dontsImage?.filename || blok?.donts?.content[0]?.content"
  >
    <v-col cols="12" :md="blok?.dontsImage?.filename ? '6' : '12'">
      <p class="mb-2 text-primary font-weight-bold">{{ $t("donts") }}</p>
      <div v-html="renderRichText(blok.donts)" class="donts" />
    </v-col>
    <v-col cols="12" md="6" v-if="blok?.dontsImage?.filename">
      <div class="dos-donts__image-container">
        <img
          class="dos-donts__image-container--image"
          :src="blok.dontsImage.filename"
          :alt="blok.dontsImage.alt"
        />
      </div>
    </v-col>
  </v-row>
</template>
